module.exports = __webpack_public_path__ + "img/start_btn.7b6c0331.png";